import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';

interface ICurrencyAddDrawerObjectProps {
  store?: any;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getCurrencyAddDrawerObject = ({ store, formObject, toggleVisibility, action }: ICurrencyAddDrawerObjectProps): any => {
  return {
    title: 'settings.currency.add.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.currency.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.currency.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
